import React, { useEffect, useState } from "react";
import { Box, Slider } from "@mui/material";
import "./createSurvey.css";

export default function SingleSlider({
  index,
  question,
  handleAnswerChange,
  currentAnswer,
}) {
  const [sliderValue, setSliderValue] = useState(currentAnswer);
  const [showSliderValue, setShowSliderValue] = useState(false);

  useEffect(() => {
    // show the slider value when slider is moved or already data exist
    if (sliderValue > 0 || sliderValue != currentAnswer) {
      setShowSliderValue(true);
    }
  }, [sliderValue]);

  useEffect(() => {
    setSliderValue(currentAnswer);
  }, [currentAnswer]);

  const handleChange = (e, newValue) => {
    setSliderValue(newValue);
    handleAnswerChange({ id: question.id, value: newValue, altered: true });
  };

  return (
    <div className="slider-conti">
      <div
        className="sliderNumber"
        // style={{
        //   fontSize: "15px",
        //   backgroundColor: value.altered ? "#92D2C4" : "white",
        //   color: value.altered ? "white" : "black",
        // }}
        style={{
          fontSize: "15px",
          backgroundColor: "white",
          color: "black",
        }}
      >
        {index}
      </div>
      <div className="sliderMain">
        <div className="slider-title">{question?.question}</div>
        <div className="slider-image">
          <Box>
            <Slider
              value={sliderValue}
              onChange={handleChange}
              color="primary"
              sx={{
                "& .MuiSlider-thumb": {
                  width: "36px",
                  height: "36px",
                  backgroundColor: "#92D2C4",
                  position: "relative",
                  "&::after": {
                    content: `"${showSliderValue ? sliderValue : ""}"`,
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "#C83C70",
                    color: "#fff",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    fontSize: "16px",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                  },
                },
                "& .MuiSlider-track": {
                  color: "#45B5B6",
                },
                "& .MuiSlider-rail": {
                  color: "#E6E6E6",
                },
              }}
              style={{
                color: "#93d3c6",
                height: "20px",
              }}
              min={0}
              max={100}
            />
          </Box>
          {/* Additional Texts Section */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gridTemplateRows: "1fr",
              gap: "8px",
              fontSize: { xs: "6px", sm: "10px", md: "12px" },
              opacity: "0.6",
              color: "black",
            }}
          >
            {[1, 2, 3, 4, 5].map((index) => (
              <Box
                key={index}
                sx={{
                  textAlign: index === 5 ? "inherit" : "center",
                  padding: "8px",
                  borderRight: index === 5 ? "none" : "1px solid #D3D3D3",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {question?.[`response_${index}`]}
              </Box>
            ))}
          </Box>
        </div>
      </div>
    </div>
  );
}
